<template>
  <div class="getSku">
    <transition name="slide-in">
      <template v-if="goodsSkuList.length>0">
        <div class="layer-sku layer-sku-list" v-if="showSku" :class="{'zIndex':showBtn}">
          <div class="layer-sku-wrap">
            <div class="close iconfont iconcha" @click="isShowSku"></div>
            <div class="layer-sku-wrap-box">
              <div class="layer-sku-info" v-for="(item,i) in goodsSkuList" :key="i">
                <div class="goods-info">
                  <div class="img-box">
                    <img :src="item.skuPicture+'?imageView2/1/w/232/h/232/format/webp&x-oss-process=image/resize,m_fill,w_232,h_232'" />
                  </div>
                  <div class="layer-sku-info-rt">
                    <div class="goods-name">{{item.name}}</div>

                    <div class="price-box">
                      <div class="goods-price" v-if="item.price>0||(item.price<=0&&item.price<0)"><em>¥</em><b>{{item.price}}</b><i v-if="item.originalPrice>0">¥{{item.originalPrice}}</i>
                        <div class="goods-stock" v-if="goodsDetail.shopGoodsConfig&&goodsDetail.shopGoodsConfig.showStock=='T'">库存：{{item.stock}}</div>
                      </div>

                      <div class="goods-credit" v-if="item.price>0&&item.credit>0">
                        <span v-if="priceOrCredit!='T'">+</span>{{item.credit}}<b>{{creditName}}<span v-if="priceOrCredit=='T'">兑换</span></b>
                      </div>
                      <div class="goods-price" v-if="item.price<=0&&item.credit>0">
                        <b>{{item.credit}}</b><em>{{creditName}}</em>
                      </div>
                    </div>
                    <!-- <div class="goods-info" v-if="productType=='normal'"><span class="canBuyNumber" v-if="goodsDetail.canBuyNumber<9999">还可购买<b>{{canBuyNumber}}</b>件</span></div> -->
                  </div>
                </div>
                <div class="buy-item">
                  <div class="label">购买数量：</div>
                  <div class="buy-num-val">
                    <div class="iconjianhao iconfont" :class="{active:item.canReduce}" @click="chooseNum('reduce',item)"></div>
                    <div class="num">
                      <input :disabled="!item.canChangeNum" @blur="numberChangeItem(item)" pattern="[0-9]*" onkeyup="value=value.replace(/[^\d]/g,'')" @focus="numberFocus()" type="number" v-model="item.number">
                    </div>
                    <div class="iconjia iconfont" :class="{active:item.canAdd}" @click="chooseNum('add',item)"></div>
                  </div>
                </div>
              </div>
              <div class="buy-item" v-if="goodsDetail.goodsType=='1'||goodsDetail.vrType=='retail'">
                <div class="label">收货方式：</div>
                <div class="way">
                  <div class="way-type" :class="deliveryLimit[1]" v-if="deliveryLimit[1]!='unable-choose'" @click="chooseDelivery(1)">物流配送</div>
                  <div class="way-type" :class="deliveryLimit[2]" v-if="deliveryLimit[2]!='unable-choose'" @click="chooseDelivery(2)">自提</div>
                  <div class="way-type" :class="deliveryLimit[3]" v-if="deliveryLimit[3]!='unable-choose'" @click="chooseDelivery(3)">客房配送</div>
                  <div class="way-type" :class="deliveryLimit[4]" v-if="deliveryLimit[4]!='unable-choose'" @click="chooseDelivery(4)">堂食</div>
                  <div class="way-type" :class="deliveryLimit[5]" v-if="deliveryLimit[5]!='unable-choose'" @click="chooseDelivery(5)">外带</div>
                </div>
              </div>

              <div class="footer" v-if="showBtn">
                <div class="btn" @click="submitGoodsResult()">确定</div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="layer-sku" v-if="showSku" :class="{'zIndex':showBtn}">
          <div class="layer-sku-wrap">
            <div class="close iconfont iconcha" @click="isShowSku"></div>
            <div class="layer-sku-info">
              <div class="img-box">
                <img :src="curGoodsInfo.currentPic+'?imageView2/1/w/232/h/232/format/webp&x-oss-process=image/resize,m_fill,w_232,h_232'" />
              </div>
              <div class="layer-sku-info-rt">
                <div class="goods-name">{{goodsDetail.name}}</div>
                <div class="goods-secondTitle" v-if="goodsDetail.secondTitle!=''">{{goodsDetail.secondTitle}}</div>
                <div class="price-box">
                  <div class="goods-price" v-if="curGoodsInfo.currentPrice>0||(curGoodsInfo.currentPrice<=0&&curGoodsInfo.currentCredit<0)"><em>¥</em><b>{{curGoodsInfo.currentPrice}}</b><i v-if="curGoodsInfo.proposedPrice>0">¥{{curGoodsInfo.proposedPrice}}</i>
                    <div class="goods-stock" v-if="goodsDetail.shopGoodsConfig&&goodsDetail.shopGoodsConfig.showStock=='T'">库存：{{curGoodsInfo.currentStock}}</div>
                  </div>

                  <div class="goods-credit" v-if="curGoodsInfo.currentPrice>0&&curGoodsInfo.currentCredit>0">
                    <span v-if="priceOrCredit!='T'">+</span>{{curGoodsInfo.currentCredit}}<b>{{creditName}}<span v-if="priceOrCredit=='T'">兑换</span></b>
                  </div>
                  <div class="goods-price" v-if="curGoodsInfo.currentPrice<=0&&curGoodsInfo.currentCredit>0">
                    <b>{{curGoodsInfo.currentCredit}}</b><em>{{creditName}}</em>
                  </div>
                </div>
                <div class="goods-info" v-if="productType=='normal'"><span class="canBuyNumber" v-if="goodsDetail.canBuyNumber<9999">已选<b>{{buyNum.number}}</b>件，还可购买<b>{{canBuyNumber}}</b>件</span></div>
              </div>
            </div>
            <div class="buy-item" v-if="goodsDetail.goodsType=='1'||goodsDetail.vrType=='retail'">
              <div class="label">收货方式：</div>
              <div class="way">
                <div class="way-type" :class="deliveryLimit[1]" v-if="deliveryLimit[1]!='unable-choose'" @click="chooseDelivery(1)">物流配送</div>
                <div class="way-type" :class="deliveryLimit[2]" v-if="deliveryLimit[2]!='unable-choose'" @click="chooseDelivery(2)">自提</div>
                <div class="way-type" :class="deliveryLimit[3]" v-if="deliveryLimit[3]!='unable-choose'" @click="chooseDelivery(3)">客房配送</div>
                <div class="way-type" :class="deliveryLimit[4]" v-if="deliveryLimit[4]!='unable-choose'" @click="chooseDelivery(4)">堂食</div>
                <div class="way-type" :class="deliveryLimit[5]" v-if="deliveryLimit[5]!='unable-choose'" @click="chooseDelivery(5)">外带</div>
              </div>
            </div>

            <div class="sku-item" v-for="(item,index) in goodsSKU.skuItem" :key="index">
              <div class="label">{{item.itemName}}：</div>
              <div class="skuArr">
                <div class="sku-type" v-for="(i,index2 ) in item.itemValue" :key="index2" @click="chooseSKU(i,index,index2,item)" :class="{'unable-choose':i.unableChooseFlag,'choose-active':i.chooseFlag}">{{i.itemValue}}</div>
              </div>
            </div>
            <div class="buy-item line">
              <div class="label">购买数量：</div>
              <div class="buy-num-val">
                <div class="iconjianhao iconfont" :class="{active:buyNum.canReduce}" @click="chooseNum('reduce')"></div>
                <div class="num">
                  <input :disabled="!canChangeNum" @blur="numberChange()" pattern="[0-9]*" onkeyup="value=value.replace(/[^\d]/g,'')" @focus="numberFocus()" type="number" v-model="buyNum.number">
                </div>
                <div class="iconjia iconfont" :class="{active:buyNum.canAdd}" @click="chooseNum('add')"></div>
              </div>
            </div>
            <div class="group-sku" v-if="groupExtra&&groupExtra.priceType=='2'&&!groupNumber&&groupExtra.list.length>1">
              <div class="group-sku-item" v-for="(item,i) in groupExtra.list" :key="i" @click="chooseGroup(item)" :class="{'active':item.active}">
                <div class="group-sku-price">¥{{item.groupPrice}}</div>
                <div class="group-sku-num">{{item.groupNumber}}人团</div>
              </div>

            </div>
            <div class="footer" v-if="showBtn">
              <div class="btn" @click="submitGoodsResult()">确定</div>
            </div>
          </div>
        </div>
      </template>
    </transition>
    <div class="bg" v-if="showSku" :class="{'zIndex':showBtn}"></div>
  </div>
</template>

<script>
import {
  jAlert3
} from '@/base/jAlert/jAlert';
import api from '@/utils/api';
import {
  getStorage
} from '@/utils/wxuser';
import {
  urlEncode,
  createUrl
} from '@/utils/index';
import gcTrack from "@/utils/gcTrack";
import moment from 'moment';
var config = {};
export default {
  data() {
    return {
      showSku: false,
      chooseSKUItem: [],
      currentSKUArr: [],
      goodsSKU: [],
      deliveryLimit: [],
      buyNum: {
        canReduce: false,
        canAdd: true,
        number: 1
      },
      curDelivery: -1,
      submitType: 0, //提交方式0购物车，1购买
      goodsResult: [{
        number: 1,
        goodsId: '',
        logoUrl: '',
        vrType: '',
        deliveryType: '',
        goodsName: '',
        credit: -1,
        price: -1,
        weight: -1,
        goodsType: '',
        stock: -1,
        skuInfo: [{
          stock: 0,
          price: 0,
          credit: 0,
          sku: []
        }],
        hotelName: ''
      }],
      wxuser: '',
      user: '',
      isCanAdd: true,
      shopMultiPriceList: [], //会员价
      creditName: getStorage('creditName') || '积分',
      preEndTime: '',
      oldBuyNum: 0, //点击前购买数量
      canChangeNum: true, //是否能改变数量
      goodsSkuList: [],
      groupExtra: '',
      groupNumber: '',
      canCheck:true,
      init:false
    };
  },
  props: {
    groupBook: {
      type: Object
    },
    curInfo: {
      type: Object
    },
    goodsDetail: {
      type: Object
    },
    goodsId: {
      type: String
    },
    productType: {
      type: String,
      default() {
        return 'normal';
      }
    },
    showBtn: {
      type: Boolean,
      default() {
        return false;
      }
    },
    goodsGroupExtra: {
      type: Object
    }
  },
  created() {
    config = getStorage('config');
    this.wxuser = getStorage('wxuser');
    this.user = getStorage('user');
  },
  watch: {
    goodsSkuListNew: {
        handler(val, oldVal) {
            if(!this.canCheck){
                this.canCheck = true
                return
            }
            
            let number = 0
            val.forEach(item=>{
                if(item.active){
                    number += item.number
                }
            
            })
            if (number <= this.goodsDetail.minLimit) {
              return;
            }
            var listBuyLimit = [];
                var goodsId = {
                    goodsId: this.goodsDetail.id,
                    number: number
                };
                listBuyLimit.push(goodsId);
                var opt = {
                    listBuyLimit: listBuyLimit,
                    openid: this.wxuser.openid
                }
                if (this.user && this.user.memberId) {
                    opt.memberId = this.user.memberId
                    var chuzhiIndex = getStorage("cardIndex") || 0;
                    opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
                }

                api.checkLimitBuy(opt).then((res) => {
                    if (res.result == 1) {
                        if (['coupon', 'pack', 'ticket'].includes(this.goodsDetail.vrType)) {
                            var obj = {
                            code: this.curInfo.vrCode || this.goodsDetail.vrCode,
                            type: this.goodsDetail.vrType,
                            number: number,
                            hotelCode: this.goodsDetail.hotelCode,
                            hotelGroupCode: this.goodsDetail.hotelGroupCode,
                            hotelGroupId: config.hotelGroupId
                            };
                            if (this.goodsDetail.srcHotelGroupCode && this.goodsDetail.srcHotelGroupCode != '') {
                            obj.srcHotelCode = this.goodsDetail.srcHotelCode
                            obj.srcHotelGroupCode = this.goodsDetail.srcHotelGroupCode
                            }
                            api.checkCouponCount(obj).then(res => {
                            if (res.result != 1) {
                                this.canCheck = false
                                this.goodsSkuList = JSON.parse(JSON.stringify(oldVal))
                                jAlert3(res.msg);
                            }
                            });
                        } 
                    } else {
                        this.canCheck = false
                        this.goodsSkuList = JSON.parse(JSON.stringify(oldVal))
                        jAlert3(res.msg);
                    }
                });
        },deep: true
    },
    groupBook(val) {
      if (val.groupNumber) {
        this.groupNumber = val.groupNumber
        if (this.goodsSKU.skuItem.length > 0) {
          this.serachGoodsSku()
        } else {
          if (this.productType == 'group') {
            if (this.groupExtra) {
              if (this.groupExtra.list && this.groupExtra.list.length > 0) {
                var index = 0

                this.groupExtra.list.forEach((item, i) => {
                  if (this.groupNumber == item.groupNumber) {
                    index = i
                  }
                  this.$set(item, 'active', false)
                })
                this.groupExtra.list[index].active = true
                this.curInfo.currentPrice = this.groupExtra.list[index].groupPrice
                this.curInfo.groupNumber = this.groupExtra.list[index].groupNumber

              }
            }
          }
        }

      } else {
        this.groupNumber = ''
      }

    },
    goodsGroupExtra(val) {

      if (val) {
        this.groupExtra = val
      }
    },
    goodsSKU(val) {
      console.log(val)
      this.$emit('getGoodsSku', val)
    },
    goodsDetail(val) {
      this.buyNum = {
        canReduce: false,
        canAdd: true,
        number: 1
      }
      this.chooseSKUItem = []
      this.currentSKUArr = []
      this.shopMultiPriceList = []
      this.getGoodsSKU()
      this.initDeliveryLimit()
    },
    currentStock(val, oldVal) {
      if (this.curInfo.number > val) {
        this.curInfo.number = val;
      }
    },
    currentSKUArr: {
      handler(val, oldVal) {
        var val = val;
        var curGroupArr = []; //当前选中的类型的组合
        var all_in_type = []; //所有单独类型属性
        var selcGroup = []; //已选择的类型ID
        var unSelcGroup = []; //未选择的类型ID
        var curTypeUnSelcArr = []; //当前选中类型下的非选中的节点
        var curSingleUnSelList = []; //当前选中类型下的非选中节点对象
        var curSingleUnSelcArr = [];
        var curUnGroupArr = [];
        var curUnSingleTypeArr = [];
        var merge = [];
        curGroupArr = this.filterProduct(val); //获取所有当前选中的类型的组合
        all_in_type = this.filterSingleProduct(curGroupArr); //获取所有类型的单独属性
        all_in_type = Array.from(new Set(all_in_type)); //数组去重
        //console.log('筛选出当前可选组合中的所有单独类型',all_in_type)
        unSelcGroup = this.groupType().unSelcGroup;
        selcGroup = this.groupType().selcGroup;
        //console.log('未选择的类型ID',unSelcGroup)
        //console.log('已选择的类型ID ',selcGroup)
        /*
              @params{array,array,array} (当前选中属性列表，当前为选中属性列表，所有可选类型的单独属性列表)
          */
        this.setBtnState(val, unSelcGroup, all_in_type); //未选择的类别的属性控制
        for (let i in val) {
          var all_in_type_item = this.update_2(val[i], val, selcGroup); //已选择的类别的属性控制
          for (let j in all_in_type_item) {
            merge.push(all_in_type_item[j]);
          }
        }
        merge = Array.from(new Set(merge));
        this.setBtnState(val, selcGroup, merge);
      },
      deep: true
    }
  },
  computed: {
    goodsSkuListNew(){
        return JSON.parse(JSON.stringify(this.goodsSkuList))
    },
    canBuyNumber() {
      var canBuyNumber = ''
      if (this.goodsDetail.canBuyNumber != undefined) {
        canBuyNumber = this.goodsDetail.canBuyNumber - this.buyNum.number > 0 ? this.goodsDetail.canBuyNumber - this.buyNum.number : 0

      }
      return canBuyNumber
    },
    curGoodsInfo() {

      return this.curInfo;
    }
  },
  methods: {
    chooseGroup(item) {

      this.groupExtra.list.forEach(groupExtra => {
        this.$set(groupExtra, 'active', false)
      })
      this.$set(item, 'active', true)
      this.curInfo.currentPrice = item.groupPrice
      this.curInfo.groupNumber = item.groupNumber
    },
    numberFocus() {
      this.oldBuyNum = this.buyNum.number
    },
    numberChangeItem(item) {
      var allNumer = 0
      this.goodsSkuList.forEach(goods => {
        allNumer += Number(goods.number)
      })

      if (!item.number || item.number <= 0 || this.productType == 'firstOrder' || this.productType == 'blindBox') {
        if (this.productType == 'firstOrder' || this.productType == 'blindBox') {
          jAlert3("只能购买一件")
        }
        item.number = this.oldBuyNum
        return;
      }
      if (this.productType == 'group') {
        if (item.number > this.goodsDetail.oneLimitNumber) {
          item.number = this.oldBuyNum
          return false;
        }
      }
      if (item.number > item.stock) {
        jAlert3('库存不足');
        item.number = this.oldBuyNum
        return false;
      }
      if (
        this.goodsDetail.buyLimit != 0 &&
        this.goodsDetail.buyLimit &&
        item.number > this.goodsDetail.buyLimit
      ) {
        item.number = this.goodsDetail.buyLimit;
        jAlert3(
          this.goodsDetail.name + '限购' + this.goodsDetail.buyLimit + '件'
        );

        return false;
      }
      if (this.goodsDetail.minLimit && allNumer < this.goodsDetail.minLimit) {
        jAlert3('最小购买数' + this.goodsDetail.minLimit)
        item.number = this.oldBuyNum
        return false;
      }
      if (this.goodsDetail.canBuyNumber) {
        if (this.buyNum.number > this.goodsDetail.canBuyNumber) {
          jAlert3('超过最大购买数');
          item.number = this.oldBuyNum
          return false
        }
      }
      var listBuyLimit = [];
      var goodsId = {
        goodsId: this.goodsDetail.id,
        number: allNumer,
      };
      listBuyLimit.push(goodsId);
      var opt = {
        listBuyLimit: listBuyLimit,
        openid: this.wxuser.openid
      }
      if (this.user && this.user.memberId) {
        opt.memberId = this.user.memberId
        var chuzhiIndex = getStorage("cardIndex") || 0;
        opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
      }

      this.canChangeNum = false
      api.checkLimitBuy(opt).then((res) => {
        if (res.result == 1) {
          if (this.goodsDetail.vrType == 'coupon' || this.goodsDetail.vrType == 'pack' || this.goodsDetail.vrType == 'ticket') {
            var obj = {
              code: this.curInfo.vrCode || this.goodsDetail.vrCode,
              type: this.goodsDetail.vrType,
              number: item.number,
              hotelCode: this.goodsDetail.hotelCode,
              hotelGroupCode: this.goodsDetail.hotelGroupCode,
              hotelGroupId: config.hotelGroupId
            };
            if (this.goodsDetail.srcHotelGroupCode && this.goodsDetail.srcHotelGroupCode != '') {
              obj.srcHotelCode = this.goodsDetail.srcHotelCode
              obj.srcHotelGroupCode = this.goodsDetail.srcHotelGroupCode
            }
            api.checkCouponCount(obj).then(res => {
              if (res.result != 1) {
                item.number = this.oldBuyNum
                this.canChangeNum = true
                jAlert3(res.msg);
              }
            });
          } else {
            this.canChangeNum = true
          }

        } else {
          item.number = this.oldBuyNum
          this.canChangeNum = true
          jAlert3(res.msg);
        }
      });
    },
    numberChange() {
      if (!this.buyNum.number || this.buyNum.number <= 0 || this.productType == 'firstOrder' || this.productType == 'blindBox') {
        if (this.productType == 'firstOrder' || this.productType == 'blindBox') {
          jAlert3("只能购买一件")
        }
        this.buyNum.number = this.oldBuyNum
        return;
      }
      if (this.productType == 'group') {
        if (this.buyNum.number > this.goodsDetail.oneLimitNumber) {
          this.buyNum.number = this.oldBuyNum
          return false;
        }
      }
      if (this.buyNum.number > this.curInfo.currentStock) {
        jAlert3('库存不足');
        this.buyNum.number = this.oldBuyNum
        return false;
      }
      if (
        this.goodsDetail.buyLimit != 0 &&
        this.goodsDetail.buyLimit &&
        this.buyNum.number > this.goodsDetail.buyLimit
      ) {
        this.buyNum.number = this.goodsDetail.buyLimit;
        jAlert3(
          this.goodsDetail.name + '限购' + this.goodsDetail.buyLimit + '件'
        );

        return false;
      }
      if (this.goodsDetail.minLimit && this.buyNum.number < this.goodsDetail.minLimit) {
        jAlert3('最小购买数' + this.goodsDetail.minLimit)
        this.buyNum.number = this.oldBuyNum
        return false;
      }
      if (this.goodsDetail.canBuyNumber) {
        if (this.buyNum.number > this.goodsDetail.canBuyNumber) {
          jAlert3('超过最大购买数');
          this.buyNum.number = this.oldBuyNum
          return false
        }
      }

      var listBuyLimit = [];
      var goodsId = {
        goodsId: this.goodsDetail.id,
        number: this.buyNum.number,
      };
      listBuyLimit.push(goodsId);
      var opt = {
        listBuyLimit: listBuyLimit,
        openid: this.wxuser.openid
      }
      if (this.user && this.user.memberId) {
        opt.memberId = this.user.memberId
        var chuzhiIndex = getStorage("cardIndex") || 0;
        opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
      }
      this.canChangeNum = false
      api.checkLimitBuy(opt).then((res) => {
        if (res.result == 1) {
          if (this.goodsDetail.vrType == 'coupon' || this.goodsDetail.vrType == 'pack' || this.goodsDetail.vrType == 'ticket') {
            var obj = {
              code: this.curInfo.vrCode || this.goodsDetail.vrCode,
              type: this.goodsDetail.vrType,
              number: this.buyNum.number,
              hotelCode: this.goodsDetail.hotelCode,
              hotelGroupCode: this.goodsDetail.hotelGroupCode,
              hotelGroupId: config.hotelGroupId
            };
            if (this.goodsDetail.srcHotelGroupCode && this.goodsDetail.srcHotelGroupCode != '') {
              obj.srcHotelCode = this.goodsDetail.srcHotelCode
              obj.srcHotelGroupCode = this.goodsDetail.srcHotelGroupCode
            }
            api.checkCouponCount(obj).then(res => {
              if (res.result != 1) {
                this.buyNum.number = this.oldBuyNum
                this.canChangeNum = true
                jAlert3(res.msg);
              }
            });
          } else {
            this.canChangeNum = true
          }

        } else {
          this.buyNum.number = this.oldBuyNum
          this.canChangeNum = true
          jAlert3(res.msg);
        }
      });
    },
    chooseDelivery(val) {
      if (this.deliveryLimit[val] == 'unable-choose') {
        return false;
      } else {
        this.$set(this.deliveryLimit, this.curDelivery, '');
        this.$set(this.deliveryLimit, val, 'choose-active');
        this.curDelivery = val;
      }
    },
    initDeliveryLimit() {
      this.curDelivery = -1;
      this.deliveryLimit = [];
      for (var i = 0; i < 6; i++) {
        this.deliveryLimit.push('unable-choose')
      }
      for (let i in this.deliveryLimit) {
        if (this.goodsDetail.deliveryLimit == '') {
          this.$set(this.deliveryLimit, i, 'unable-choose');
        } else if (
          this.goodsDetail.deliveryLimit &&
          this.goodsDetail.deliveryLimit.indexOf(i) == -1
        ) {
          this.$set(this.deliveryLimit, i, 'unable-choose');
        } else {
          this.$set(this.deliveryLimit, i, '');
          if (this.curDelivery < 0) {
            this.$set(this.deliveryLimit, i, 'choose-active');
            this.curDelivery = i;
          }
        }
      }

      if (
        this.goodsDetail.goodsType == '0'
      ) {
        this.curDelivery = -1;
      }
      // console.log(this.curDelivery)
    },
    getGoodsSKU() {
      let opt = {
        hotelGroupCode: config.hotelGroupCode,
        isAllShopMultiPrice: 'T' //显示所以会员等级价格
      };
      opt.goodsId = this.goodsId;
      this.curInfo.currentPic = this.goodsDetail.logo;
      if (this.productType == 'flash') {
        opt.goodsId = this.goodsDetail.flashGoodsId;
        opt.activityGoodsId = this.goodsId;
      } else if (this.productType == 'group') {
        opt.goodsId = this.goodsId;
        opt.activityGoodsId = this.goodsDetail.activityGoodsId;
      }
      if (this.productType == 'presale' || this.productType == 'firstOrder' || this.productType == 'prePay') {
        opt.goodsId = this.goodsDetail.id;
        opt.activityGoodsId = this.goodsDetail.activityGoodsId;
      }
      if (this.goodsDetail.minLimit) {
        this.buyNum.number = this.goodsDetail.minLimit
      }
      if (getStorage('levelCode')) {
        opt.cardCode = getStorage('levelCode')
      }
      // if (this.goodsDetail.shopGoodsConfig && this.goodsDetail.shopGoodsConfig.preEndTime != '') {
      //   if (moment(this.goodsDetail.shopGoodsConfig.preEndTime).format("YYYY") == "2099") {
      //     this.preEndTime = "长期有效";
      //   } else {
      //     this.preEndTime = moment(this.goodsDetail.shopGoodsConfig.preEndTime).format("YYYY-MM-DD")
      //   }
      // }
      this.getCurrentCard();
      var cardType = ""
      if (this.user && this.user.memberId && this.productType == 'normal') {
        var chuzhiIndex = getStorage('cardIndex') || 0;
        opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
        cardType = this.user.cardListDto[chuzhiIndex].cardType;
      }
      if (this.productType == 'blindBox') {
        this.goodsSKU = {
          shopMultiPriceList: [],
          skuItem: [],
          stock: []
        }
        this.hasConfigSKU = false;
        this.curInfo.hasConfigSKU = false;
        this.init = true
        this.$emit('update');
      } else {
        api.goodsSku(opt).then(res => {
          this.init = true
          this.goodsSKU = res.retVal;
          var curMultiPriceList = [];
          let hotelList = [];
          // this.shopMultiPriceList = this.goodsSKU.shopMultiPriceList;
          this.goodsSKU.stock.forEach(item => {

            item.hotelList.forEach(hotel => {
              let hotelCode = ''
              hotelList.forEach(n => {
                if (n.hotelCode == hotel.hotelCode) {
                  hotelCode = hotel.hotelCode
                }
              })
              if (!hotelCode) {
                hotelList.push(hotel)
              }
            })
          })


          this.goodsSKU.shopMultiPriceList.forEach(item => {
            try {
              var curCardType = item.cardLevel.split('@')[0]
              if (cardType == curCardType) {
                this.shopMultiPriceList.push(item)
              }
              if (getStorage('levelCode')) {
                if (item.cardCode == getStorage('levelCode')) {
                  this.shopMultiPriceList.push(item)
                }

              }
            } catch (error) {

            }
          })
          if (this.shopMultiPriceList.length > 0) {
            this.shopMultiPriceList.forEach(item => {
              if (item.cardCode == opt.cardLevel) {
                curMultiPriceList.push(item);
              }
              if (getStorage('levelCode')) {
                if (item.cardCode == getStorage('levelCode')) {
                  curMultiPriceList.push(item);
                }

              }
            });
          }

          this.$set(this.curInfo, 'hasConfigSKU', false)
          if (this.goodsSKU.skuItem.length > 0) {
            this.hasConfigSKU = true;
            this.curInfo.hasConfigSKU = true;
            for (let i in this.goodsSKU.skuItem) {
              this.chooseSKUItem[i] = {
                itemId: this.goodsSKU.skuItem[i].itemId,
                itemName: this.goodsSKU.skuItem[i].itemName,
                itemValue: null,
                itemValueId: null
              };

              for (let j in this.goodsSKU.skuItem[i].itemValue) {
                this.$set(
                  this.goodsSKU.skuItem[i].itemValue[j],
                  'chooseFlag',
                  false
                );
              }
              if (this.productType == 'prePay') {
                //预付定金
                for (var m in this.goodsSKU.stock) {
                  if (this.goodsDetail.presellType == 1) {
                    this.goodsSKU.stock[m].price =
                      (
                        this.goodsSKU.stock[m].price *
                        this.goodsDetail.presellValue
                      ).toFixed(2) / 100;
                  } else {
                    this.goodsSKU.stock[
                      m
                    ].price = this.shopPrepayGoods.presellValue;
                  }
                }
              }
              if (curMultiPriceList.length > 0) {
                for (var m in this.goodsSKU.stock) {
                  for (var n in curMultiPriceList) {
                    if (
                      curMultiPriceList[n].skuId &&
                      this.goodsSKU.stock[m].skuId == curMultiPriceList[n].skuId
                    ) {
                      this.goodsSKU.stock[m].price = curMultiPriceList[n].price;
                      if (curMultiPriceList[n].priceType == 'member') {
                        this.goodsSKU.stock[m].credit = curMultiPriceList[n].credit
                      }
                      if (curMultiPriceList[n].price == 0) {
                        this.goodsSKU.stock[m].stock = 0;
                      }
                    }
                  }
                }
              }
            }

          } else {

            if (this.productType == 'prePay') {
              this.goodsDetail.price = this.goodsDetail.presellValueNew;
              this.curInfo.currentPrice = this.goodsDetail.presellValueNew;
            }

            if (curMultiPriceList.length > 0) {
              this.goodsDetail.price = curMultiPriceList[0].price;
              this.curInfo.currentPrice = curMultiPriceList[0].price;
              this.curInfo.shopMultiPriceList = this.shopMultiPriceList;
              if (curMultiPriceList[0].priceType == 'member'
              ) {
                this.curInfo.currentCredit = curMultiPriceList[0].credit
              }
              
              this.$emit('update', this.curInfo);
            }

            if (this.productType == 'group') {
              if (this.groupExtra) {
                if (this.groupExtra.list && this.groupExtra.list.length > 0) {
                  var index = 0

                  this.groupExtra.list.forEach((item, i) => {
                    if (this.groupNumber == item.groupNumber) {
                      index = i
                    }
                    this.$set(item, 'active', false)
                  })
                  this.groupExtra.list[index].active = true
                  this.curInfo.currentPrice = this.groupExtra.list[index].groupPrice
                  this.curInfo.groupNumber = this.groupExtra.list[index].groupNumber

                }
              }
            }
            this.hasConfigSKU = false;
            this.curInfo.hasConfigSKU = false;
          }
          this.$emit('update');

          if (this.hasConfigSKU) {
            this.initSku();
            this.$emit('getHotelList', hotelList);

          }
        });
      }
    },
    initSku() {
      var val = [];
      var curGroupArr = []; //当前选中的类型的组合
      var all_in_type = []; //所有单独类型属性
      var selcGroup = []; //已选择的类型ID
      var unSelcGroup = []; //未选择的类型ID
      var curTypeUnSelcArr = []; //当前选中类型下的非选中的节点
      var curSingleUnSelList = []; //当前选中类型下的非选中节点对象
      var curSingleUnSelcArr = [];
      var curUnGroupArr = [];
      var curUnSingleTypeArr = [];
      var merge = [];
      curGroupArr = this.filterProduct(val); //获取所有当前选中的类型的组合
      all_in_type = this.filterSingleProduct(curGroupArr); //获取所有类型的单独属性
      all_in_type = Array.from(new Set(all_in_type)); //数组去重
      unSelcGroup = this.groupType().unSelcGroup;
      selcGroup = this.groupType().selcGroup;
      /*
            @params{array,array,array} (当前选中属性列表，当前为选中属性列表，所有可选类型的单独属性列表)
        */
      this.setBtnState(val, unSelcGroup, all_in_type); //未选择的类别的属性控制

      for (let i in val) {
        var all_in_type_item = this.update_2(val[i], val, selcGroup); //已选择的类别的属性控制
        for (let j in all_in_type_item) {
          merge.push(all_in_type_item[j]);
        }
      }
      merge = Array.from(new Set(merge));
      this.setBtnState(val, selcGroup, merge);
      //初始化选择最低价格
      if (curGroupArr.length) {
        let minPrice = curGroupArr[0].price;
        let maxPrice = curGroupArr[0].price;
        let helpCode = curGroupArr[0].helpCode;
        curGroupArr.forEach((item, index) => {
          if (item.price < minPrice) {
            minPrice = item.price;
            helpCode = item.helpCode;
          }
          if (item.price > maxPrice) {
            maxPrice = item.price;
          }
        });
        if (maxPrice <= 0) {
          const result = curGroupArr.reduce((min, current) => (current.credit < min.credit ? current : min));
          helpCode = result.helpCode
        }

        let typeId = helpCode.split(',');
        let allTypeId = [];
        typeId.forEach((item, index) => {
          allTypeId[index] = {
            itemId: item.split('itemId')[1].split('_')[0],
            itemValueId: item.split('itemValueId')[1].split('_')[0]
          };
        });
        var types = [];
        allTypeId.forEach((type, index) => {
          this.goodsSKU.skuItem.forEach((item, index) => {
            if (item.itemId == type.itemId) {
              item.itemValue.forEach((i, index2) => {
                if (i.itemValueId == type.itemValueId) {
                  this.chooseSKU(i, index, index2, item, 'T');
                }
              });
            }
          });
        });
      }
    },

    update_2(curVal, val, selcGroup) {
      /*
            @params{val} 已选择的属性
        */
      var curGroupArr = [];
      var all_in_type = [];
      var merge = [];
      var select_ids2 = this.delArrayVal(val, curVal);

      curGroupArr = this.filterProduct(select_ids2); //获取所有当前选中的类型的组合
      all_in_type = this.filterSingleProduct(curGroupArr); //获取所有类型的单独
      all_in_type = Array.from(new Set(all_in_type)); //数组去重
      return all_in_type;
    },
    setBtnState(val, arr, groupList) {
      /* 未选中的类型的单个元素 */
      for (let i in this.goodsSKU.skuItem) {
        for (let j in arr) {
          if (this.goodsSKU.skuItem[i].itemId == arr[j].itemId) {
            //未选中类型
            for (let k in this.goodsSKU.skuItem[i].itemValue) {
              if (
                this.inArray(
                  this.goodsSKU.skuItem[i].itemValue[k].itemValueId,
                  groupList
                ) != -1
              ) {
                this.goodsSKU.skuItem[i].itemValue[k].unableChooseFlag = false;
              } else {
                this.goodsSKU.skuItem[i].itemValue[k].unableChooseFlag = true;
              }
            }
          }
        }
      }
    },
    groupType() {
      var selcGroup = [],
        unSelcGroup = [];

      for (let i in this.chooseSKUItem) {
        /* 取出当前已选择的类型ID */
        if (this.chooseSKUItem[i].itemValueId != null) {
          selcGroup.push(this.chooseSKUItem[i]);
          /* 取出当前未选择的类型ID */
        } else if (this.chooseSKUItem[i].itemValueId == null) {
          unSelcGroup.push(this.chooseSKUItem[i]);
        }
      }
      return {
        selcGroup: selcGroup,
        unSelcGroup: unSelcGroup
      };
    },
    filterSingleProduct(curGroupArr) {
      /* 筛选出当前可选组合中的所有单独类型  */
      var singleTypeArr = [];
      for (let i in curGroupArr) {
        for (let j in curGroupArr[i].sku) {
          singleTypeArr.push(curGroupArr[i].sku[j].itemValueId); //itemValueId
        }
      }
      return singleTypeArr;
    },
    filterProduct(val) {
      /* 获取所有当前选中的类型的组合 */
      var allValIn = true;
      var curGroupArr = [];
      for (let i in this.goodsSKU.stock) {
        allValIn = true;
        for (let k = 0; k < val.length; k++) {
          if (this.goodsSKU.stock[i].helpCode.indexOf(val[k]) == -1) {
            allValIn = false;
            break;
          }
        }
        if (allValIn) {
          if (this.goodsSKU.stock[i].stock > 0) {
            curGroupArr.push(this.goodsSKU.stock[i]);
          }
        }
      }
      //console.log('所有当前选中的类型的组合',curGroupArr)
      return curGroupArr;
    },
    serachGoodsSku(init) {

      var keyArr = [];
      var key = '';
      for (let i = 0; i < this.chooseSKUItem.length; i++) {
        keyArr.push(
          'itemId' +
          this.chooseSKUItem[i].itemId +
          '_' +
          this.chooseSKUItem[i].itemName +
          '_itemValueId' +
          this.chooseSKUItem[i].itemValueId +
          '_' +
          this.chooseSKUItem[i].itemValue
        );
      }
      key = keyArr.join(',');
      /* var key = this.currentSKUArr.join(','); */
      var findKeyFlag = false;
      var hasStock = [];
      var idx = -1;
      for (let i in this.goodsSKU.stock) {
        if (this.goodsSKU.stock[i].stock > 0) {
          hasStock.push(this.goodsSKU.stock[i]);
        }
      }
      for (let i in hasStock) {
        console.log(key);
        if (hasStock[i].helpCode === key) {
          findKeyFlag = true;
          idx = i;
          break;
        }
      }
      if (findKeyFlag) {
        this.curInfo.currentStock = hasStock[idx].stock;
        this.curInfo.currentPrice = hasStock[idx].price;
        this.curInfo.currentCredit = hasStock[idx].credit;
        this.curInfo.currentWigth = hasStock[idx].weight;
        this.curInfo.skuId = hasStock[idx].skuId;
        this.curInfo.maxCreditDedu = hasStock[idx].maxCreditDedu;
        this.curInfo.currentPic = hasStock[idx].skuPicture;
        this.curInfo.vrCode = hasStock[idx].code;
        this.curInfo.proposedPrice = hasStock[idx].originalPrice;
        if(this.goodsDetail.isGetCredit=='T'){
          this.curInfo.rewardCredit  = hasStock[idx].rewardCredit;
        }
       
        if (this.productType == 'group') {
          if (hasStock[idx].groupExtra) {
            this.groupExtra = JSON.parse(hasStock[idx].groupExtra)
            if (this.groupExtra.list && this.groupExtra.list.length > 0) {
              var index = 0
              this.groupExtra.list.forEach((item, i) => {
                if (this.groupNumber == item.groupNumber) {
                  index = i
                }
                this.$set(item, 'active', false)
              })
              this.groupExtra.list[index].active = true
              this.curInfo.currentPrice = this.groupExtra.list[index].groupPrice
              this.curInfo.groupNumber = this.groupExtra.list[index].groupNumber

            }

          } else if (this.groupExtra && this.groupExtra.list && this.groupExtra.list.length > 0) {
            this.curInfo.groupNumber = this.groupExtra.list[0].groupNumber
          }
        }

        // this.curInfo.currentPic.push(hasStock[idx].skuPicture);
        var itemValue = '';
        this.currentSKUArr.forEach((item, index) => {
          if (index == this.currentSKUArr.length - 1) {
            itemValue += item.split('_')[3];
          } else {
            itemValue += item.split('_')[3] + ',';
          }
        });
        this.curInfo.currentItemValue = itemValue;
        if (
          this.goodsDetail.vrType == 'coupon' ||
          this.goodsDetail.vrType == 'ticket'
        ) {
          var goodsTime = '';

          if (hasStock[idx].vrDateType == 'byDate') {
            if (this.goodsDetail.vrEndDate == null) {
              goodsTime = '';
            } else {
              if (moment(hasStock[idx].vrEndDate).format('YYYY') == '2099') {
                goodsTime = '长期有效';
              } else {
                goodsTime =
                  moment(hasStock[idx].vrStartDate).format('YYYY年MM月DD日') +
                  '-' +
                  moment(hasStock[idx].vrEndDate).format('YYYY年MM月DD日');
              }
            }
          } else {
            if (hasStock[idx].vrBeginDay == 0) {
              goodsTime = '购买后' + hasStock[idx].vrValidDays + '天内有效';
            } else {
              goodsTime =
                '购买后第' +
                hasStock[idx].vrBeginDay +
                '天生效，有效期' +
                hasStock[idx].vrValidDays +
                '天';
            }
          }
          this.curInfo.goodsTime = goodsTime;
        }
      } else {

        this.curInfo.currentStock = this.goodsDetail.stock;
        this.curInfo.currentPrice = this.goodsDetail.price;
        this.curInfo.currentCredit = this.goodsDetail.credit;
        this.curInfo.currentWigth = this.goodsDetail.weight;
        this.curInfo.maxCreditDedu = this.goodsDetail.maxCreditDedu;
        this.curInfo.vrCode = this.goodsDetail.vrCode;
        this.curInfo.proposedPrice = this.goodsDetail.proposedPrice;
        if(this.goodsDetail.shopGoodsConfig&&this.goodsDetail.isGetCredit=='T'){
          this.curInfo.rewardCredit  = this.goodsDetail.shopGoodsConfig.rewardCredit;
        }
        
        if (this.goodsDetail.pictureUrl) {
          this.curInfo.currentPic = this.goodsDetail.pictureUrl
            .split(',')
            .filter(item => item);
        }

      }
      if (init == 'T' && this.shopMultiPriceList.length > 0) {
        this.curInfo.memberPrice = this.curInfo.currentPrice;
        if (this.curInfo.skuId) {
          this.curInfo.shopMultiPriceList = [];
          this.shopMultiPriceList.forEach(item => {
            if (item.skuId == this.curInfo.skuId) {
              this.curInfo.shopMultiPriceList.push(item);
            }
          });
        }
      }
      this.$emit('update', this.curInfo);
    },
    isEmptySKUTips(chooseSKUItem) {
      var tips = '';
      for (let i in chooseSKUItem) {
        if (!chooseSKUItem[i].itemValueId) {
          tips += chooseSKUItem[i].itemName + ' ';
        }
      }
      return tips;
    },
    removeItem(item, arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] === item) {
          arr.splice(i, 1);
        }
      }
    },
    inArray(string, array) {
      var idx = -1;
      for (let i in array) {
        if (array[i] === string) {
          idx = i;
          return idx;
        }
      }
      return idx;
    },
    delArrayVal(arr, val) {
      // 去除 数组 arr中的 val ，返回一个新数组
      var a = [];
      for (let k in arr) {
        if (arr[k] !== val) {
          a.push(arr[k]);
        }
      }
      return a;
    },
    chooseSKU(item, index, idx, parentItem, init) {
      //item:当前选中的元素,index:当前选中元素的索引，idx:当前选中元素的类型的索引，parentItem:当前选中元素的类型对象,init是否是第一次初始化
      var parentItem = parentItem; //商品类型对象
      var id = item.itemValueId; //当前选中规格对象
      if (item.unableChooseFlag) {
        return false;
      }
      var sum = 0;
      var currentChooseIndex = -1;
      for (let i in this.goodsSKU.skuItem[index].itemValue) {
        if (this.goodsSKU.skuItem[index].itemValue[i].chooseFlag) {
          currentChooseIndex = i;
          sum++;
        }
      }
      if (!!sum) {
        //如果当前已经有选中的目标了
        if (currentChooseIndex == idx) {
          item.chooseFlag = false;
          for (let i in this.chooseSKUItem) {
            if (
              this.goodsSKU.skuItem[index].itemId ==
              this.chooseSKUItem[i].itemId
            ) {
              this.chooseSKUItem[i].itemValueId = null;
              this.chooseSKUItem[i].itemValue = null;
              this.removeItem(
                'itemId' +
                parentItem.itemId +
                '_' +
                parentItem.itemName +
                '_itemValueId' +
                id +
                '_' +
                item.itemValue,
                this.currentSKUArr
              );
            }
          }
        } else {
          this.goodsSKU.skuItem[index].itemValue[
            currentChooseIndex
          ].chooseFlag = false;
          item.chooseFlag = true;
          for (let i in this.chooseSKUItem) {
            if (
              this.goodsSKU.skuItem[index].itemId ==
              this.chooseSKUItem[i].itemId
            ) {
              this.chooseSKUItem[i].itemValueId = item.itemValueId;
              this.chooseSKUItem[i].itemValue = item.itemValue;
              this.removeItem(
                'itemId' +
                parentItem.itemId +
                '_' +
                parentItem.itemName +
                '_itemValueId' +
                this.goodsSKU.skuItem[index].itemValue[currentChooseIndex]
                  .itemValueId +
                '_' +
                this.goodsSKU.skuItem[index].itemValue[currentChooseIndex]
                  .itemValue,
                this.currentSKUArr
              );
            }
          }
          this.currentSKUArr.push(
            'itemId' +
            parentItem.itemId +
            '_' +
            parentItem.itemName +
            '_itemValueId' +
            id +
            '_' +
            item.itemValue
          );
        }
      } else {
        item.chooseFlag = !item.chooseFlag;
        for (let i in this.chooseSKUItem) {
          if (
            this.goodsSKU.skuItem[index].itemId == this.chooseSKUItem[i].itemId
          ) {
            this.chooseSKUItem[i].itemValueId = item.itemValueId;
            this.chooseSKUItem[i].itemValue = item.itemValue;
          }
        }
        this.currentSKUArr.push(
          'itemId' +
          parentItem.itemId +
          '_' +
          parentItem.itemName +
          '_itemValueId' +
          id +
          '_' +
          item.itemValue
        );
      }

      this.serachGoodsSku(init);
    },
    isShowSku(val, type, goodsSkuList) {
      this.submitType = val;
      if (goodsSkuList) {
        this.goodsSkuList = goodsSkuList
      }
      if (type == 'show' && this.showSku) {
        this.submitGoodsResult();
      } else {
        this.showSku = !this.showSku;
      }
    },
    chooseNum(dir, item) {
      if (item) {
        var allNumer = 0
        this.goodsSkuList.forEach(goods => {
          allNumer += goods.number
        })
        var number = item.number
      } else {
        var allNumer = this.buyNum.number
        var number = this.buyNum.number
      }
      if (dir === 'add') {
        if (this.productType == 'group') {
          if (number >= this.goodsDetail.oneLimitNumber && this.goodsDetail.oneLimitNumber > 0) {

            jAlert3(`只能购买${this.goodsDetail.oneLimitNumber}件`)
            return false;
          }
        }
        if (this.productType == 'firstOrder') {
          jAlert3("只能购买一件")
          return false
        }
        if (this.productType == 'blindBox') {
          jAlert3("不能再多了，一次性只能购买一件哦！")
          return false
        }
        if (!this.isCanAdd) {
          return false
        }
        this.isCanAdd = false
        var listBuyLimit = [];
        var goodsId = {
          goodsId: this.goodsDetail.id,
          number: allNumer + 1,
        };
        listBuyLimit.push(goodsId);
        var opt = {
          listBuyLimit: listBuyLimit,
          openid: this.wxuser.openid
        }
        if (this.user && this.user.memberId) {
          opt.memberId = this.user.memberId
          var chuzhiIndex = getStorage("cardIndex") || 0;
          opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
        }

        if (item) {
          this.isCanAdd = true
          item.number++;
          if (item.number == item.stock) {
            item.canAdd = false;
          } else {
            item.canAdd = true;
          }
          if (allNumer == this.goodsDetail.buyLimit) {
            item.canAdd = false;
          } else {
            item.canAdd = true;
          }

        } else {
          api.checkLimitBuy(opt).then((res) => {
            if (res.result == 1) {
              if (this.goodsDetail.vrType == 'coupon' || this.goodsDetail.vrType == 'pack' || this.goodsDetail.vrType == 'ticket') {
                var obj = {
                  code: this.curInfo.vrCode || this.goodsDetail.vrCode,
                  type: this.goodsDetail.vrType,
                  number: number + 1,
                  hotelCode: this.goodsDetail.hotelCode,
                  hotelGroupCode: this.goodsDetail.hotelGroupCode,
                  hotelGroupId: config.hotelGroupId
                };
                if (this.goodsDetail.srcHotelGroupCode && this.goodsDetail.srcHotelGroupCode != '') {
                  obj.srcHotelCode = this.goodsDetail.srcHotelCode
                  obj.srcHotelGroupCode = this.goodsDetail.srcHotelGroupCode
                }
                api.checkCouponCount(obj).then(res => {
                  this.isCanAdd = true
                  if (res.result == 1) {
                    if (number >= this.curInfo.currentStock) {
                      jAlert3('库存不足');
                      this.buyNum.canAdd = false;
                      return false;
                    }
                    if (
                      this.goodsDetail.buyLimit != 0 &&
                      this.goodsDetail.buyLimit &&
                      number >= this.goodsDetail.buyLimit
                    ) {
                      if (item) {
                        item.number = this.goodsDetail.buyLimit;
                      } else {
                        this.buyNum.number = this.goodsDetail.buyLimit;
                      }
                      jAlert3(
                        this.goodsDetail.name +
                        '限购' +
                        this.goodsDetail.buyLimit +
                        '件'
                      );
                      if (item) {
                        item.canAdd = false
                      } else {
                        this.buyNum.canAdd = false;
                      }

                      return false;
                    }
                    if (this.goodsDetail.canBuyNumber != undefined) {
                      if (this.buyNum.allNumer >= this.goodsDetail.canBuyNumber) {
                        jAlert3('超过最大购买数');
                        this.buyNum.canAdd = false;
                        return false
                      }
                    }
                    if (item) {
                      item.number++;
                      if (item.number == item.stock) {
                        item.canAdd = false;
                      } else {
                        item.canAdd = true;
                      }
                      if (allNumer == this.goodsDetail.buyLimit) {
                        item.canAdd = false;
                      } else {
                        item.canAdd = true;
                      }
                    } else {
                      this.buyNum.number++;
                      if (this.buyNum.number == this.curInfo.currentStock) {
                        this.buyNum.canAdd = false;
                      } else {
                        this.buyNum.canAdd = true;
                      }
                      if (allNumer == this.goodsDetail.buyLimit) {
                        this.buyNum.canAdd = false;
                      } else {
                        this.buyNum.canAdd = true;
                      }
                    }

                  } else {
                    jAlert3(res.msg);
                  }
                });
              } else {
                this.isCanAdd = true
                if (item) {
                  if (item.number >= item.currentStock) {
                    jAlert3('库存不足');
                    item.canAdd = false;
                    return false;
                  }
                } else {
                  if (this.buyNum.number >= this.curInfo.currentStock) {
                    jAlert3('库存不足');
                    this.buyNum.canAdd = false;
                    return false;
                  }
                }

                if (
                  this.goodsDetail.buyLimit != 0 &&
                  this.goodsDetail.buyLimit &&
                  this.buyNum.number >= this.goodsDetail.buyLimit
                ) {
                  this.buyNum.number = this.goodsDetail.buyLimit;
                  jAlert3(
                    this.goodsDetail.name + '限购' + this.goodsDetail.buyLimit + '件'
                  );
                  this.buyNum.canAdd = false;
                  return false;
                }
                if (this.goodsDetail.canBuyNumber) {
                  if (allNumer >= this.goodsDetail.canBuyNumber) {
                    jAlert3('超过最大购买数');
                    if (item) {
                      item.canAdd = false;
                    } else {
                      this.buyNum.canAdd = false;
                    }

                    return false
                  }
                }
                if (item) {
                  item.number++;
                  if (item.number == item.stock) {
                    item.canAdd = false;
                  } else {
                    item.canAdd = true;
                  }
                  if (allNumer == this.goodsDetail.buyLimit) {
                    item.canAdd = false;
                  } else {
                    item.canAdd = true;
                  }
                } else {
                  this.buyNum.number++;
                  if (this.buyNum.number == this.curInfo.currentStock) {
                    this.buyNum.canAdd = false;
                  } else {
                    this.buyNum.canAdd = true;
                  }
                  if (allNumer == this.goodsDetail.buyLimit) {
                    this.buyNum.canAdd = false;
                  } else {
                    this.buyNum.canAdd = true;
                  }
                }

              }
            } else {
              this.isCanAdd = true
              jAlert3(res.msg);
            }
          });

        }

      } else if (dir === 'reduce') {
        if (this.goodsDetail.minLimit && allNumer <= this.goodsDetail.minLimit) {
          jAlert3('最小购买数' + this.goodsDetail.minLimit)
          return false;
        }
        if (item) {
          if (item.number == 1) {
            return false;
          }
          item.number--;
          if (item.number == 1) {
            item.canReduce = false;
          } else {
            item.canReduce = true;
          }
        } else {
          if (this.buyNum.number == 1) {
            return false;
          }
          this.buyNum.number--;
          if (this.buyNum.number == 1) {
            this.buyNum.canReduce = false;
          } else {
            this.buyNum.canReduce = true;
          }
        }

      }
    },
    getShopCartNum() {
      let opt = {
        hotelGroupCode: config.hotelGroupCode,
        equipment: config.equipment,
        appid: config.appid
      }
      if (this.wxuser && this.wxuser.openid) {
        opt.openid = this.wxuser.openid
      } else {
        return false
      }
      if (this.user && this.user.memberId) {
        opt.memberId = this.user.memberId
      }

      api.listShopCart(opt).then(res => {
        if (res.result == 1) {
          this.$store.commit("SHOPCART_NUM", res.retVal.length);

        } else {
          jAlert3(res.msg)
        }
      })
    },
    addShopCart() {
      if (!this.isCanAdd) {
        return false;
      }
      this.isCanAdd = false;
      var skuInfo = [];
      var deliveryType = '';
      skuInfo.push({});
      skuInfo[0].price = this.currentPrice;
      skuInfo[0].credit = this.currentCredit;
      skuInfo[0].stock = this.currentStock;
      skuInfo[0].sku = this.chooseSKUItem;
      if (this.curDelivery != -1) {
        deliveryType = this.curDelivery;
      }

      let obj = {
        goodsId: this.goodsDetail.id,
        number: this.buyNum.number,
        skuInfo: JSON.stringify(skuInfo),
        openid: this.wxuser.openid,
        hotelCode: config.hotelCode,
        hotelGroupCode: config.hotelGroupCode,
        equipment: 'desktop',
        deliveryType: deliveryType,
        appid: config.appid
      };
      if (this.user && this.user.memberId) {
        obj.memberId = this.user.memberId;
        var chuzhiIndex = getStorage("cardIndex") || 0;
        obj.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
      }

      if (this.curInfo.skuId) {
        obj.skuId = this.curInfo.skuId
      }
      if (this.goodsDetail.distributorOpenId) {
        obj.distributorId = this.goodsDetail.distributorId;
        obj.distributorOpenId = this.goodsDetail.distributorOpenId;
      }
      if (this.goodsDetail.distributorOpenIdDis) {
        obj.distributorOpenIdDis = this.goodsDetail.distributorOpenIdDis;
      }
      if (this.goodsDetail.activityId) {
        obj.activityId = this.goodsDetail.activityId;
      }
      if (this.goodsDetail.pickUpPointCode && (deliveryType == '2' || deliveryType == '4' || deliveryType == '5')) {
        obj.pickUpPoint = this.goodsDetail.pickUpPointCode + '@' + this.goodsDetail.pickUpPointName + '@' + this.goodsDetail.pickId
      }
      obj.url = createUrl(obj);
      api.saveShopCart(obj).then(res => {
        this.isCanAdd = true;
        this.showSku = false;
        if (res.result === 1) {
          this.$gc.track({
            behaviorType: 3,
            itemId: this.goodsDetail.id
          });

          var data = {
            commodity_id: this.goodsDetail.id,
            commodity_name: this.goodsDetail.name,
            commodity_tag: [],
            commodity_type: this.goodsDetail.vrType,
            original_price: this.goodsDetail.proposedPrice,
            present_price: this.curInfo.currentPrice,
            commodity_quantity: this.buyNum.number,
            preferential_price: 0
          }
          if (this.goodsDetail.shopGoodsConfig && this.goodsDetail.shopGoodsConfig.goodsCity) {
            data.commodity_tag.push(this.goodsDetail.shopGoodsConfig.goodsCity)
          }

          gcTrack.track("SC_AddToShoppingCart", data)
          this.$emit('updateCar');
          this.getShopCartNum()
          jAlert3('添加成功');
        } else {
          jAlert3(res.msg);
        }
      });
    },
    saveGoodsResult() {
      if (this.submitType == 1) {
        var deliveryType = '';
        if (this.curDelivery != -1) {
          deliveryType = this.curDelivery;
        }
        if (this.goodsSkuList.length > 0) {
          this.goodsResult = []
          this.goodsSkuList.forEach(item => {
            var goodsResult = {
              skuId: item.skuId,
              stock: item.stock,
              price: item.price,
              credit: item.credit,
              deliveryType: deliveryType,
              skuInfo: [{
                stock: item.stock,
                price: item.price,
                credit: item.credit,
                sku: JSON.stringify([{
                  itemId: item.sku[0].itemId,
                  itemName: item.sku[0].itemName,
                  itemValue: item.sku[0].itemValue,
                  itemValueId: item.sku[0].itemValueId
                }])
              }]
            }
            if (this.goodsDetail.needIdCard) {
              goodsResult.needIdCard = this.goodsDetail.needIdCard
            }
            if (this.goodsDetail.distributorOpenId) {
              goodsResult.distributorId = this.goodsDetail.distributorId;
              goodsResult.distributorOpenId = this.goodsDetail.distributorOpenId;
            }
            if (this.goodsDetail.distributorOpenIdDis) {
              goodsResult.distributorOpenIdDis = this.goodsDetail.distributorOpenIdDis;
            }
            goodsResult.goodsId = this.goodsDetail.id;
            if (this.goodsDetail.shopGoodsConfig) {
              goodsResult.limitPayment = this.goodsDetail.shopGoodsConfig.limitPayment;
            } else {
              goodsResult.limitPayment = '';
            }

            goodsResult.hotelName = this.goodsDetail.hotelCodeName || this.goodsDetail.hotelName;

            goodsResult.number = item.number;
            goodsResult.paymentMethod = '';
            goodsResult.maxCreditDedu = item.maxCreditDedu;

            goodsResult.logoUrl = item.skuPicture;
            goodsResult.vrType = this.goodsDetail.vrType;
            goodsResult.vrCode = this.goodsDetail.vrCode;
            goodsResult.goodsName = this.goodsDetail.name;
            goodsResult.goodsType = this.goodsDetail.goodsType;
            goodsResult.hotelCode = this.goodsDetail.hotelCode;
            goodsResult.belongHotelCode = this.goodsDetail.belongHotelCode
            this.goodsResult.push(goodsResult)
          })

        } else {
          if (this.hasConfigSKU) {
            this.goodsResult[0].skuId = this.curInfo.skuId;
            this.goodsResult[0].skuInfo[0].stock = this.curInfo.currentStock;
            this.goodsResult[0].skuInfo[0].price = this.curInfo.currentPrice;
            this.goodsResult[0].skuInfo[0].credit = this.curInfo.currentCredit;
            this.goodsResult[0].skuInfo[0].sku = JSON.stringify(
              this.chooseSKUItem
            );
            this.goodsResult[0].maxCreditDedu = this.curInfo.maxCreditDedu
            console.log(this.chooseSKUItem)
          } else {
            this.goodsResult[0].maxCreditDedu = this.goodsDetail.maxCreditDedu;
          }
          var deliveryType = '';
          if (this.curDelivery != -1) {
            deliveryType = this.curDelivery;
          }
          if (
            this.goodsDetail.isWechatProfitSharing &&
            this.goodsDetail.isWechatProfitSharing == 'T'
          ) {
            this.goodsResult[0].isWechatProfitSharing = 'T';
          }
          if (this.goodsDetail.needIdCard) {
            this.goodsResult[0].needIdCard = this.goodsDetail.needIdCard
          }
          if (this.goodsDetail.distributorOpenId) {
            this.goodsResult[0].distributorId = this.goodsDetail.distributorId;
            this.goodsResult[0].distributorOpenId = this.goodsDetail.distributorOpenId;
          }
          if (this.goodsDetail.distributorOpenIdDis) {
            this.goodsResult[0].distributorOpenIdDis = this.goodsDetail.distributorOpenIdDis;
          }
          this.goodsResult[0].goodsId = this.goodsDetail.id;
          if (this.goodsDetail.shopGoodsConfig) {
            this.goodsResult[0].limitPayment = this.goodsDetail.shopGoodsConfig.limitPayment;
          } else {
            this.goodsResult[0].limitPayment = '';
          }

          this.goodsResult[0].hotelName = this.goodsDetail.hotelCodeName || this.goodsDetail.hotelName;
          this.goodsResult[0].deliveryType = deliveryType;
          this.goodsResult[0].skuId = this.curInfo.skuId;
          this.goodsResult[0].stock = this.curInfo.currentStock;
          this.goodsResult[0].price = this.curInfo.currentPrice;
          this.goodsResult[0].credit = this.curInfo.currentCredit;
          this.goodsResult[0].number = this.buyNum.number;
          this.goodsResult[0].paymentMethod = '';



          this.goodsResult[0].logoUrl = this.curInfo.currentPic;
          this.goodsResult[0].vrType = this.goodsDetail.vrType;
          this.goodsResult[0].vrCode = this.goodsDetail.vrCode;
          this.goodsResult[0].goodsName = this.goodsDetail.name;
          this.goodsResult[0].goodsType = this.goodsDetail.goodsType;
          this.goodsResult[0].hotelCode = this.goodsDetail.hotelCode;
          this.goodsResult[0].belongHotelCode = this.goodsDetail.belongHotelCode
          console.log(this.curInfo.groupNumber)
          if (this.curInfo.groupNumber) {
            this.goodsResult[0].groupNumber = this.curInfo.groupNumber
          }
        }

        this.$emit('customEvent', this.goodsResult);
      } else {
        if (this.goodsSkuList.length > 0) {

          if (!this.isCanAdd) {
            return false;
          }
          var num = 0
          this.isCanAdd = false;
          this.goodsSkuList.forEach(item => {
            var skuInfo = [];
            var deliveryType = '';
            skuInfo.push({});
            skuInfo[0].price = item.price;
            skuInfo[0].credit = item.credit;
            skuInfo[0].stock = item.stock;
            skuInfo[0].sku = [{
              itemId: item.sku[0].itemId,
              itemName: item.sku[0].itemName,
              itemValue: item.sku[0].itemValue,
              itemValueId: item.sku[0].itemValueId
            }]
            if (this.curDelivery != -1) {
              deliveryType = this.curDelivery;
            }

            let obj = {
              goodsId: this.goodsDetail.id,
              number: item.number,
              skuInfo: JSON.stringify(skuInfo),
              openid: this.wxuser.openid,
              hotelCode: config.hotelCode,
              hotelGroupCode: config.hotelGroupCode,
              equipment: 'desktop',
              deliveryType: deliveryType,
              appid: config.appid
            };
            if (this.user && this.user.memberId) {
              obj.memberId = this.user.memberId;
              var chuzhiIndex = getStorage("cardIndex") || 0;
              obj.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
            }

            obj.skuId = item.skuId
            if (this.goodsDetail.distributorOpenId) {
              obj.distributorId = this.goodsDetail.distributorId;
              obj.distributorOpenId = this.goodsDetail.distributorOpenId;
            }
            if (this.goodsDetail.distributorOpenIdDis) {
              obj.distributorOpenIdDis = this.goodsDetail.distributorOpenIdDis;
            }
            if (this.goodsDetail.activityId) {
              obj.activityId = this.goodsDetail.activityId;
            }
            if (this.goodsDetail.pickUpPointCode && (deliveryType == '2' || deliveryType == '4' || deliveryType == '5')) {
              obj.pickUpPoint = this.goodsDetail.pickUpPointCode + '@' + this.goodsDetail.pickUpPointName
            }
            obj.url = createUrl(obj);
            api.saveShopCart(obj).then(res => {
              num++
              if (num == this.goodsSkuList.length) {
                this.isCanAdd = true;
                this.showSku = false;
              }

              if (res.result === 1) {
                this.$gc.track({
                  behaviorType: 3,
                  itemId: this.goodsDetail.id
                });

                var data = {
                  commodity_id: this.goodsDetail.id,
                  commodity_name: this.goodsDetail.name,
                  commodity_tag: [],
                  commodity_type: this.goodsDetail.vrType,
                  original_price: this.goodsDetail.proposedPrice,
                  present_price: this.goodsDetail.price,
                  commodity_quantity: item.number,
                  preferential_price: 0
                }
                if (this.goodsDetail.shopGoodsConfig && this.goodsDetail.shopGoodsConfig.goodsCity) {
                  data.commodity_tag.push(this.goodsDetail.shopGoodsConfig.goodsCity)
                }

                gcTrack.track("SC_AddToShoppingCart", data)

                if (num == this.goodsSkuList.length) {
                  this.$emit('updateCar');
                  jAlert3('添加成功');
                  this.getShopCartNum()
                }

              } else {
                jAlert3(res.msg);
              }
            });
          })
        } else {
          this.addShopCart();
        }

      }
    },
    checkCanSubmit(cb) {
      var obj = {
        mobile: this.user.mobile,
        hotelGroupCode: config.hotelGroupCode,
        hotelCode: config.hotelCode
      };
      api.checkCanSubmit(obj).then((res1) => {
        if (res1.result == 1) {
          cb && cb()
        } else {
          jAlert3('对不起，您当前不符合购买条件');
        }
      })

    },
    isLimitRegisterTime(limitRegisterTime){
      var chuzhiIndex = getStorage('cardIndex') || 0
      let cardCreateDatetime = this.user.cardListDto[chuzhiIndex].cardCreateDatetime
      let cardType = this.user.cardListDto[chuzhiIndex].cardType
      let cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel
      if(limitRegisterTime.items&&limitRegisterTime.items.length>0){
        let {isLevelIn,isTypeIn,isIn,passLevel,passType,passIn,noPass} = false
        for (const item of limitRegisterTime.items) {
          const isTimeValid = moment(cardCreateDatetime).isBefore(moment(item.limitRegisterTime));
          if (cardType === item.memberCardType) {
            if (item.memberLevelList.includes(cardLevel)) {
              isLevelIn = true
              if (isTimeValid) {
                passLevel = true;
              }
            }else{
              isTypeIn = true
              if(isTimeValid){
                console.log(item)

                passType = true;
              }
            }
          }
          if(!item.memberCardType){
            isIn = true
            if (isTimeValid) {
              passIn = true;
            }
          }
        }
        if(isLevelIn){
          if(passLevel){
            noPass = true
          }
        }else if(isTypeIn){
          if(passType){
            noPass = true
          }
        }else if(isIn){
          if(passIn){
            noPass = true
          }
        }
        if(noPass){
          jAlert3('您当前不满足购买条件！')
          return false
        }else{
          return true
        }
      }else{
        return true
      }
    },
    submitGoodsResult() {
      if(!this.init){
        return
      }
      if (this.goodsDetail) {
        // if (this.goodsDetail.preStartTime) {
        //     var startTime = new Date(
        //         this.goodsDetail.preStartTime.replace(/-/g, "/")
        //     ).getTime();
        //     var endTime = new Date(
        //         this.goodsDetail.preEndTime.replace(/-/g, "/")
        //     ).getTime();
        // } else if (this.goodsDetail.vrStartDate) {
        //     var startTime = new Date(
        //         this.goodsDetail.vrStartDate.replace(/-/g, "/")
        //     ).getTime();
        //     var endTime = new Date(
        //         this.goodsDetail.vrEndDate.replace(/-/g, "/")
        //     ).getTime();
        // }
        // var nowDate = new Date().getTime();
        // if (nowDate > endTime) {
        //     jAlert3('活动已结束');
        //     return false;
        // }
        if (this.goodsDetail.onUnsale && this.goodsDetail.onUnsale == '1') {
          jAlert3(this.goodsDetail.name + '已下架，不可购买');
          return false;
        }
        if (this.goodsDetail.isHalt && this.goodsDetail.isHalt == 'T') {
          jAlert3(this.goodsDetail.name + '已删除，不可购买');
          return false;
        }
        if (this.buyNum.number > this.curInfo.currentStock) {
          jAlert3('库存不足');
          return false
        }

        if (this.goodsDetail.canBuyNumber != undefined) {
          if (this.buyNum.number > this.goodsDetail.canBuyNumber) {
            jAlert3('超过最大购买数');
            this.buyNum.canAdd = false;
            return false
          }
        }
        if (
          this.goodsDetail.meberCanBuyFlag &&
          this.goodsDetail.meberCanBuyFlag == "F"
        ) {
          jAlert3("会员等级不符合");
          return false;
        }
      }
      try {
        if (
          this.goodsDetail.goodsType == '1' && this.curDelivery == -1
        ) {
          jAlert3('请选择配送方式');
          return false;
        }
        // if (this.goodsDetail.shopGoodsConfig) {
        //   var startTimeDate = this.goodsDetail.shopGoodsConfig.preStartTime;
        //   var endTimeDate = this.goodsDetail.shopGoodsConfig.preEndTime;
        // } else {
        //   var startTimeDate = this.goodsDetail.preStartTime;
        //   var endTimeDate = this.goodsDetail.preEndTime;
        // }
        // if (startTimeDate) {
        //   var startTime = new Date(startTimeDate.replace(/-/g, "/")).getTime();
        //   var endTime = new Date(endTimeDate.replace(/-/g, "/")).getTime();
        // } else if (this.goodsDetail.vrStartDate) {
        //   var startTime = new Date(
        //     this.goodsDetail.vrStartDate.replace(/-/g, "/")
        //   ).getTime();
        //   var endTime = new Date(
        //     this.goodsDetail.vrEndDate.replace(/-/g, "/")
        //   ).getTime();
        // }
        // var nowDate = new Date().getTime();

        // if (nowDate < startTime) {
        //   jAlert3("商品还未开售哦~");
        //   return false;
        // }
        // if (nowDate > endTime) {
        //   jAlert3("活动已经结束");
        //   return false;
        // }
      } catch (e) {
        //TODO handle the exception
      }
      if (this.goodsDetail.extraConfigMap && this.goodsDetail.extraConfigMap.onlyMainAccount == 'T') {
        if (this.user && this.user.memberId) {
          var chuzhiIndex = getStorage("cardIndex") || 0;
          if (this.user.cardListDto[chuzhiIndex].cardMaster) {
            jAlert3('商品限制主卡购买！')
            return
          }
        }
      }
      if (this.goodsDetail.limitRegisterTime) {
        let limitRegisterTime = JSON.parse(this.goodsDetail.limitRegisterTime) 
        if(limitRegisterTime.isOpen=='T'){
          if(!this.isLimitRegisterTime(limitRegisterTime)){
            return
          }
        }else if(limitRegisterTime&&limitRegisterTime.after){
          if (this.user && this.user.memCreateDateTime) {
            if (moment(this.user.memCreateDateTime).isBefore(moment(limitRegisterTime.after))) {
              jAlert3('您当前不满足购买条件！')
              return;
            }
          }
        }
        
      }
      let timeLimit = getStorage('shop_goods_time_limit')
      if (timeLimit) {
        timeLimit = JSON.parse(timeLimit)
        if (timeLimit.startTime) {
          const start = moment().startOf('day').add(moment.duration(timeLimit.startTime));
          const end = moment().startOf('day').add(moment.duration(timeLimit.endTime));
          const now = moment();
          if (now.isBetween(start, end)) {
            jAlert3(`当前系统升级，${timeLimit.startTime}-${timeLimit.endTime}期间暂不可购买`)
            return;
          }
        }


      }
      var chooseSKUItem = this.chooseSKUItem;
      var tips = this.isEmptySKUTips(chooseSKUItem);
      if (!!tips) {
        jAlert3('请选择' + tips);
        return false;
      }
      if (this.isLogin()) {
        if ((this.goodsDetail.allowDistributorBuy && this.goodsDetail.allowDistributorBuy == 'F') || (this.goodsDetail.shopGoodsConfig && this.goodsDetail.shopGoodsConfig.allowDistributorBuy == 'F') && this.productType == 'normal') {
          this.checkCanSubmit(() => {
            this.saveGoodsResult();
          })

        } else {

          this.saveGoodsResult();
        }

      }

    }
  }
};
</script>

<style lang="less" scoped>
@import url("~@/styles/mixin.less");

.bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 8;

  &.zIndex {
    z-index: 98;
  }
}

.layer-sku {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9; // background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;

  &.zIndex {
    z-index: 100;
  }

  &.layer-sku-list {
    .layer-sku-wrap {
      border-radius: 0.32rem 0.32rem 0px 0px;
      padding-bottom: 1.6rem;

      .layer-sku-wrap-box {
        max-height: 450px;
        overflow-y: auto;
      }

      .layer-sku-info {
        padding-top: 0.266667rem;
        padding-bottom: 0;
        border-bottom: 1px solid #e8e8e8;
        display: block;

        .goods-info {
          display: flex;
        }

        .img-box {
          margin-top: 0;
        }

        .buy-item {
          padding-top: 0.266667rem;
          padding-bottom: 0.133333rem;
          border-top: 0;
        }
      }
    }
  }

  .layer-sku-wrap {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.426667rem 1.333333rem;
    background: #fff;

    .close {
      font-size: 12px;
      position: absolute;
      right: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 0.26rem;
      width: 0.7rem;
      height: 0.7rem;
      z-index: 9;
    }

    .layer-sku-info {
      display: flex;
      padding-bottom: 0.266667rem;

      .img-box {
        height: 2.4rem;
        width: 2.4rem;
        border-radius: 4px;
        overflow: hidden;
        margin-top: -0.266667rem;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      }

      img {
        width: 100%;
        height: 100%;
      }

      .layer-sku-info-rt {
        flex: 1;
        position: relative;
        padding-top: 0.266667rem;
        margin-left: 0.213333rem;

        .goods-name {
          font-size: 15px;
          color: #333333;
          line-height: 0.64rem;
          height: 0.64rem;
          padding-right: 0.34rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }

        .goods-secondTitle {
          margin-top: 0.266667rem;
          font-size: 14px;
          color: #666666;
          height: 0.533333rem;
          line-height: 0.533333rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }

        .price-box {
          .goods-price {
            margin-top: 0.133333rem;

            em {
              font-size: 12px;
              font-family: @price-font-family;
              margin-right: 2px;
              color: @color-price;
            }

            b {
              font-size: @price-font-size-big;
              font-family: @price-font-family;
              color: @color-price;
            }

            i {
              font-family: @price-font-family;
              font-size: 12px;
              color: #999999;
              text-decoration: line-through;
            }

            .goods-stock {
              display: inline-block;
              margin-left: 0.533333rem;
              font-size: 12px;
              color: #666;
            }
          }

          .goods-credit {
            font-family: @price-font-family;
            font-size: 14px;
            color: @color-theme;

            b {
              font-size: 10px;
              color: @color-theme;
            }
          }
        }

        .goods-info {
          margin-top: 0.266667rem;
          font-size: 12px;
          color: #999999;

          .canBuyNumber {
            margin-right: 5px;
          }

          b {
            color: @color-price;
          }
        }

        .goods-credit {
          font-family: PingFangSC-Regular;
          margin-top: 0.2rem;
          font-size: 12px;
        }

        .goods-label {
          display: flex;

          span {
            float: left;
            padding: 0 20rpx;
            height: 40rpx;
            line-height: 40rpx;
            margin-right: 10rpx;
            color: #fff;
            border-radius: 3px;
          }
        }

        .goods-name {
          // display: flex;
          // align-items: center;
          font-weight: bold;
          font-family: PingFang-SC;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
      }
    }

    .sku-item {
      display: flex;
      max-height: 5rem;
      overflow-y: scroll;
      margin-bottom: 10px;
      .label {
        width: 5em;
        text-align: right;
        font-size: 14px;
        color: #333333;
        display: flex;
        align-items: center; // line-height: 0.853333rem;
        height: 0.853333rem;
        overflow: hidden;
        justify-content: flex-end;
      }

      .skuArr {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        margin-left: -0.48rem;
        width: 100%;
        margin-bottom: -10px;
        .sku-type {
          float: left;
          margin-bottom: 0.266667rem;
          display: flex;
          border-radius: 3px;
          justify-content: center;
          align-items: center;
          line-height: 0.853333rem;
          color: #273346;
          margin-left: 0.48rem;
          border: 1px solid #999;
          box-sizing: border-box;
          background: #fff;
          padding: 0 0.266667rem;
          min-width: 2rem;

          &.choose-active {
            background: @color-sub;
            border: 1px solid @color-theme;
            color: @color-theme;
          }

          &.unable-choose {
            color: #d7dade;
          }
        }
      }
    }

    .buy-item {
      display: flex;
      width: 100%;
      justify-content: space-between;
      border-top: 1px solid #e8e8e8;
      padding: 0.266667rem 0;

      &.line {
        padding: 0.266667rem 0 0.453333rem 0;

        .label {
          line-height: 0.533333rem;
          height: 0.533333rem;
        }
      }

      .label {
        font-size: 14px;
        color: #333333;
        line-height: 0.853333rem;
        height: 0.853333rem;
      }

      .buy-num-val {
        display: flex;
        align-items: center;

        .iconjianhao,
        .iconjia {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
        }

        .iconjianhao {
          font-size: 10px;
        }

        .num {
          margin: 0 0.213333rem;
          line-height: 0.533333rem;

          input {
            border: 1px solid #ddd;
            width: 1.06667rem;
            text-align: center;
            border-radius: 0;

            &:disabled {
              background: #fff;
            }
          }
        }
      }

      .way {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        margin-top: -0.266667rem;
        margin-left: -0.48rem;

        .way-type {
          float: left;
          display: flex;
          padding: 0 0.32rem;
          border-radius: 3px;
          justify-content: center;
          align-items: center;
          height: 0.853333rem;
          color: #333;
          width: 4em;
          margin-top: 0.266667rem;
          margin-left: 0.48rem;
          border: 1px solid #eee;
          background: #fff;
          box-sizing: content-box;

          &.choose-active {
            background: @color-sub;
            border: 1px solid @color-theme;
            color: @color-theme;
          }

          &.unable-choose {
            color: #d7dade;
          }
        }
      }
    }

    .group-sku {
      margin-top: -0.133333rem;
      border-top: 1px solid #e8e8e8;
      display: flex;
      flex-wrap: wrap;
      line-height: 1.4;

      .group-sku-item {
        height: 1.226667rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 2.853333rem;
        margin-right: 0.293333rem;
        box-sizing: border-box;
        background: #ffffff;
        border: 0.5px solid #e8e8e8;
        border-radius: 3px;
        color: #333333;
        margin-bottom: 0.266667rem;

        &.active {
          background: @color-theme;
          color: #fff;
        }

        &:nth-child(3n) {
          margin-right: 0;
        }

        .group-sku-price,
        .group-sku-num {
          font-size: 12px;
        }
      }
    }

    .buy-btn {
      width: 100%;
      height: 88rpx;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      color: #fff;
      margin-top: 40rpx;
      background: linear-gradient(
        170deg,
        rgba(82, 134, 219, 1) 0%,
        rgba(41, 100, 207, 1) 100%
      );

      button {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: none;
        color: #fff;

        &::after {
          border: none;
        }
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.1);
    height: 1.333333rem;
    box-sizing: border-box;
    display: flex;
    background: @color-theme;
    align-items: center;

    .btn {
      height: 100%;
      width: 100%;
      color: #fff;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layerSku.vue